import styled from "styled-components";

export const DotLoading = ({size, space} = {size: 6, space: 5}) => {
    return (
        <DotLoadingContainer size={size} space={space}>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
        </DotLoadingContainer>
    )
}

const DotLoadingContainer = styled.div<{size?: number, space?: number}>`
  display: flex;
  align-items: center;

  .dot {
    width: ${props => props.size || 6}px;
    height: ${props => props.size || 6}px;
    background-color: ${props => props.theme.main};
    border-radius: 50%;
    margin: 0 1px;
    animation: bounce 1s infinite ease-in-out;
  }

  .dot:nth-child(2) {
    animation-delay: 0.5s;
  }

  .dot:nth-child(3) {
    animation-delay: 1s;
  }

  @keyframes bounce {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-${props => props.space || 5}px);
    }
  }
`;